import { Icon } from '@chakra-ui/react';

export default function SFPlusCircleFilledIcon(props) {
  return (
    <Icon
      width={18}
      height={18}
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
      verticalAlign='center'
      viewBox='0 0 18 18'
    >
      <path d='M9 15.246c-3.264 0-5.977-2.713-5.977-5.976 0-3.27 2.707-5.977 5.971-5.977 3.27 0 5.983 2.707 5.983 5.977 0 3.263-2.707 5.976-5.977 5.976m-2.86-5.97c0 .298.212.497.516.497H8.49v1.84c0 .3.205.516.504.516a.49.49 0 0 0 .516-.516v-1.84h1.84c.298 0 .515-.199.515-.498a.495.495 0 0 0-.515-.515H9.51V6.926a.497.497 0 0 0-.516-.522c-.299 0-.504.217-.504.522V8.76H6.656a.49.49 0 0 0-.515.515' />
    </Icon>
  );
}
